/**
 * Comment Utility Functions
 *
 * URL parsing and board/post ID extraction.
 */

import { commentForm } from "./comment-form";

interface BoardAndPostIds {
    boardId: string;
    postId: number | null;
}

class CommentUtils {
    public static getBoardAndPostIds(): BoardAndPostIds {
        let boardId: string | undefined;
        let postId: number | null;

        const elementModalRoot = commentForm.getSearchRoot();
        const elementModalForm = commentForm.isElementModalOpen() ? commentForm.getCommentForm(elementModalRoot) : null;
        if (elementModalForm) {
            boardId = elementModalForm.dataset.boardId;
            postId = this.toPostIdOrNull(elementModalForm.dataset.postId);
            return { boardId: boardId || "default", postId };
        }

        const pageCommentForm = commentForm.getCommentForm(document);
        if (pageCommentForm) {
            boardId = pageCommentForm.dataset.boardId;
            postId = this.toPostIdOrNull(pageCommentForm.dataset.postId);
        } else {
            boardId = this.getBoardIdFromUrl();
            postId = this.getPostIdFromUrl();
        }

        return { boardId: boardId || "default", postId };
    }

    public static getBoardIdFromUrl(): string {
        const pathParts = window.location.pathname.split("/");
        const postsIndex = pathParts.indexOf("posts");
        return postsIndex !== -1 ? pathParts[postsIndex + 1] : "default";
    }

    public static getPostIdFromUrl(): number | null {
        const pathParts = window.location.pathname.split("/");
        const postsIndex = pathParts.indexOf("posts");

        if (postsIndex === -1) {
            return null;
        }

        const secondPostsIndex = pathParts.indexOf("posts", postsIndex + 1);

        if (secondPostsIndex !== -1) {
            return secondPostsIndex + 1 < pathParts.length
                ? this.toPostIdOrNull(pathParts[secondPostsIndex + 1])
                : null;
        }

        const potentialPostId = pathParts[postsIndex + 2];
        const routeKeywords = ["search", "create", "edit", "page"];
        if (routeKeywords.includes(potentialPostId)) {
            return null;
        }
        return this.toPostIdOrNull(potentialPostId);
    }

    private static toPostIdOrNull(value: string | null | undefined): number | null {
        if (!value) {
            return null;
        }

        const postId = Number(value);
        return Number.isFinite(postId) && postId > 0 ? postId : null;
    }
}

export { CommentUtils };
